<template>
  <FormulateInput
    v-bind="field"
    validation-behavior="live"
    class="p-0"
    :value="computedValue"
    :fullObject="fullObject"
    @input="handleInput"
    @update:fullObject="$emit('update:fullObject', $event)"
  />
</template>

<script>
export default {
  props: {
    value: {},
    field: {},
    fullObject: {},
    customerObj: {},
    isShowingData: {},
  },
  emits: ['input', 'update:fullObject'],
  computed: {
    computedValue() {
      // if it's empty, always return null
      if (this.value === '' || this.value === false) return null

      return typeof this.value === 'string' ? Number(this.value) : this.value
    },
  },
  watch: {
    customerObj(newValue) {
      if (this.isShowingData) return
      
      if (newValue.id === null || newValue.marketing_user?.id === null) {
        this.$emit('input', null)
        return
      }

      this.$emit('input', newValue.marketing_user?.id)
      this.$emit('update:fullObject', newValue.marketing_user)
    },
  },
  methods: {
    handleInput(newValue) {
      // if newValue is empty, always set null
      if (newValue === '' || newValue === false || newValue === undefined) {
        this.$emit('input', null)
        return
      }

      // nothing happened when newValue is null
      if (newValue === null) return

      this.$emit('input', Number(newValue))
    },
  },
}
</script>
